export class ListGoogleWorkspacesResponse {
    'googleWorkspaces';
    'nextToken';
    'totalCount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "googleWorkspaces",
            "baseName": "googleWorkspaces",
            "type": "Array<GoogleWorkspace>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspacesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
